import React from 'react';
import Input from '../input';
import Icon from '../icon';

var transferSearch = function transferSearch(props) {
  var prefixCls = props.prefixCls,
      placeholder = props.placeholder,
      onChange = props.onChange,
      handleClear = props.handleClear,
      value = props.value,
      disabled = props.disabled;

  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e);
    }
  };

  var handleClearFn = function handleClearFn(e) {
    e.preventDefault();

    if (!disabled && handleClear) {
      handleClear(e);
    }
  };

  var prefixIcon = /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-prefix")
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "search"
  }));
  var suffixIcon = value && value.length > 0 ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-suffix"),
    onClick: handleClearFn
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close-solid"
  })) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    borderType: "bordered",
    placeholder: placeholder,
    className: prefixCls,
    value: value,
    onChange: handleChange,
    disabled: disabled,
    prefix: prefixIcon,
    suffix: suffixIcon
  }));
};

transferSearch.defaultProps = {
  placeholder: ''
};
export default transferSearch;